import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";

import {
  AsignarResponsableIsoBase,
  DatosAsignacionIso,
  VistaAsignacionIso,
} from "../../shared/incidencias-iso/asignar-responsable-iso-base";
import { RespuestaIso, idUsuarioEmpleadoIso } from "../../shared/incidencias-iso/incidencias-iso.comun";
import { Empleado } from "../../shared/model/empleado/empleado.model";
import { IncidenciaIA } from "../../shared/model/iso42001/incidencia-ia.model";
import { IncidenciasIAService } from "../incidencias-ia.service";

export type AsignarResponsableIAData = DatosAsignacionIso<IncidenciaIA>;

@Component({
  selector: "app-asignar-responsable-ia",
  standalone: true,
  templateUrl: "./asignar-responsable-ia.component.html",
  styleUrls: ["./asignar-responsable-ia.component.css"],
  imports: [CommonModule, FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule],
})
export class AsignarResponsableIAComponent extends AsignarResponsableIsoBase<IncidenciaIA> {
  readonly vista: VistaAsignacionIso = {
    claseModal: "incidencia-ia-ticket-modal",
    titulo: "Asignar responsable IA",
    etiquetaResponsable: "Responsable de seguimiento",
    clasePanel: "incidencia-ia-select-panel",
    etiquetaMotivo: "Motivo de la asignación o reasignación",
    placeholderMotivo: "Describe por qué se asigna o cambia el responsable",
    sinResponsables: "No hay usuarios activos con perfil Lider tecnico IA o Responsable IA.",
  };
  advertencia = "";

  protected readonly incidenciasService = inject(IncidenciasIAService);

  get resumenIncidencia(): string {
    return `${this.data?.incidencia?.herramientaIaConsecutivo || "IA"} - ${this.data?.incidencia?.herramientaIaNombre || "Sin herramienta"}`;
  }

  /** La lista de IA puede llegar sola o dentro de responsables, empleados o list; si no se puede leer, se avisa. */
  protected override recibirResponsables(res: RespuestaIso<IncidenciaIA>): void {
    try {
      super.recibirResponsables(res);
    } catch {
      this.error = "No fue posible interpretar la lista de responsables.";
    }
  }

  protected listaResponsables(res: RespuestaIso<IncidenciaIA>): Empleado[] {
    return this.extraerResponsables(res);
  }

  protected crearAsignacion(responsable: Empleado): IncidenciaIA {
    return {
      idIncidenciaIa: this.data.incidencia.idIncidenciaIa,
      idEmpleadoResponsableSeguimiento: responsable.idEmpleado,
      idUsuarioResponsableSeguimiento: idUsuarioEmpleadoIso(responsable),
      responsableSeguimientoPerfil: this.perfilResponsable(responsable),
      responsableSeguimientoCargo: this.perfilResponsable(responsable),
      nombreResponsableSeguimiento: this.nombreResponsable(responsable),
    };
  }

  private extraerResponsables(res: any): Empleado[] {
    if (Array.isArray(res)) {
      return res;
    }
    if (Array.isArray(res?.responsables)) {
      return res.responsables;
    }
    if (Array.isArray(res?.empleados)) {
      return res.empleados;
    }
    if (Array.isArray(res?.list)) {
      return res.list;
    }
    return [];
  }
}
